"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _reactRedux = require("react-redux");

var _commonData = require("../../store/commonData/commonData.selector");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    invisibleCountriesCount: {
      fontSize: 16,
      color: palette.link.main,
      cursor: 'pointer'
    }
  };
});

var CountriesNames = function CountriesNames(_ref2) {
  var countryIds = _ref2.countryIds,
      _ref2$visibleCount = _ref2.visibleCount,
      visibleCount = _ref2$visibleCount === void 0 ? 3 : _ref2$visibleCount,
      boxProps = (0, _objectWithoutProperties2.default)(_ref2, ["countryIds", "visibleCount"]);
  var classes = useStyles();
  var countryItems = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _commonData.makeGetCountriesByIds)(countryIds);
  }, [countryIds]));
  var countryNames = (0, _react.useMemo)(function () {
    return countryItems.slice(0, visibleCount).map(function (country) {
      return country.name;
    }).join(', ');
  }, [countryItems, visibleCount]);
  var invisibleCountryNames = (0, _react.useMemo)(function () {
    return countryItems.slice(visibleCount, countryItems.length).map(function (country) {
      return country.name;
    });
  }, [countryItems, visibleCount]);
  var hasInvisibleCountries = invisibleCountryNames.length > 0;
  return /*#__PURE__*/_react.default.createElement(_material.Box, boxProps, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static"
  }, countryNames, ' ', hasInvisibleCountries && /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "inline-block"
  }, /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    title: invisibleCountryNames.join(', '),
    placement: "right-end"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.invisibleCountriesCount,
    component: "span"
  }, "+", invisibleCountryNames.length)))));
};

var _default = /*#__PURE__*/(0, _react.memo)(CountriesNames);

exports.default = _default;